import React, { useState } from "react";
import "../Style/ManagerLoginChange.css";

const ManagerLoginChange = () => {
    const [login, setLogin] = useState("");
    const [currentPassword, setCurrentPassword] = useState("");
    const [password, setPassword] = useState("");
    const [loading, setLoading] = useState(false);
    const [message, setMessage] = useState(null);
    const [isError, setIsError] = useState(false);

    const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5002";

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!login.trim() || !currentPassword.trim() || !password.trim()) {
            setMessage("Բոլոր դաշտերը պարտադիր են։");
            setIsError(true);
            return;
        }

        if (password.trim().length < 8) {
            setMessage("Նոր գաղտնաբառը պետք է պարունակի առնվազն 8 նշան։");
            setIsError(true);
            return;
        }

        setLoading(true);
        setMessage(null);
        try {
            const token = localStorage.getItem("token");
            const response = await fetch(`${API_URL}/manager-change`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
                body: JSON.stringify({ username: login, currentPassword, password }),
            });

            const data = await response.json();

            if (response.ok) {
                setMessage(data.message || "Հաջողությամբ փոփոխվեց։");
                setIsError(false);
                setLogin("");
                setCurrentPassword("");
                setPassword("");
            } else {
                setMessage(data.message || "Ինչ-որ սխալ տեղի ունեցավ։");
                setIsError(true);
            }
        } catch (error) {
            console.error("🛑 Frontend error:", error);
            setMessage("Սերվերի խնդիր։ Խնդրում ենք փորձել ավելի ուշ։");
            setIsError(true);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="manager-login-body">
            <form onSubmit={handleSubmit} className="manager-login-container">
                <h2>Մենեջերի փոփոխություն</h2>

                {message && (
                    <div
                        className={`manager-login-message ${
                            isError ? "error" : "success"
                        }`}
                    >
                        {message}
                    </div>
                )}

                <div className="manager-login-form">
                    <label className="manager-login-label">Նոր լոգին</label>
                    <input
                        type="text"
                        value={login}
                        onChange={(e) => setLogin(e.target.value)}
                        className="manager-login-input"
                        placeholder="Նոր լոգին"
                    />
                </div>
                <div className="manager-login-form">
                    <label className="manager-login-label">Ընթացիկ գաղտնաբառ</label>
                    <input
                        type="password"
                        value={currentPassword}
                        onChange={(e) => setCurrentPassword(e.target.value)}
                        className="manager-login-input"
                        placeholder="Ընթացիկ գաղտնաբառ"
                    />
                </div>
                <div className="manager-login-form">
                    <label className="manager-login-label">Նոր գաղտնաբառ</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="manager-login-input"
                        placeholder="Նոր գաղտնաբառ (առնվազն 8 նշան)"
                    />
                </div>
                <button
                    type="submit"
                    className="manager-login-button"
                    disabled={loading}
                >
                    {loading ? "Խնդրում ենք սպասել..." : "Փոխել"}
                </button>
            </form>
        </div>
    );
};

export default ManagerLoginChange;
